module.exports = __webpack_public_path__ + "static/media/toto_thumb_even.8ab2b9af.jpg";